import React from 'react';
import './index.css';

const AgreementPage: React.FC = () => {
  return (
    <div className="agreement-page">
      <h1>用户协议</h1>
      
      <section className="agreement-info">
        <p><strong>公司名称：</strong>重庆首页科技有限公司</p>
        <p><strong>AI软件名称：</strong>NovaFlow视频生成平台</p>
        <p><strong>软件版本：</strong>1.4.0</p>
        <p><strong>底层AI能力提供方：</strong>火山引擎（视频生成API）</p>
        <p><strong>编制日期：</strong>2026年7月14日</p>
      </section>

      <section className="agreement-section">
        <h2>一、软件基本情况</h2>
        <p>本软件为本公司自主研发的AI漫剧创作平台，用于辅助漫剧内容创作。平台通过调用火山引擎视频生成API等人工智能能力，实现视频生成及相关创作功能。软件仅作为创作工具，由用户自主输入文本、图片等创作素材，并由用户自主选择生成结果。</p>
      </section>

      <section className="agreement-section">
        <h2>二、AI模型来源</h2>
        <p>本平台所使用的AI生成能力来源于火山引擎开放平台API接口。本公司依据火山引擎开放平台相关服务协议合法接入Seedance并使用相关模型能力。</p>
      </section>

      <section className="agreement-section">
        <h2>三、生成内容权属说明</h2>
        <ol>
          <li>本平台仅提供AI创作工具及技术服务，不主张用户依法享有的生成内容权利。</li>
          <li>用户输入的文本、图片、角色设定等素材，其合法权益归用户或依法享有权利的主体所有。</li>
          <li>用户利用本平台生成的图片、视频、漫画、漫剧等内容，在符合国家法律法规及底层AI服务协议约定的前提下，其知识产权及使用权归属于用户或依法享有权利的主体。</li>
          <li>本平台不会擅自将用户生成内容用于其他商业用途，法律法规另有规定或经用户授权的除外。</li>
        </ol>
      </section>

      <section className="agreement-section">
        <h2>四、备案说明</h2>
        <p>本次提交备案的漫剧作品使用本公司自主研发AI软件制作，底层生成能力由火山引擎API提供。根据平台服务协议及本平台用户协议，生成内容的相关权利由用户或依法享有权利的主体享有。</p>
      </section>
    </div>
  );
};

export default AgreementPage;
